export const basePath = `/date/seasonal/`;
